import { render } from "./CInputNaive.vue?vue&type=template&id=2a2ef2ec&scoped=true"
import script from "./CInputNaive.vue?vue&type=script&lang=js"
export * from "./CInputNaive.vue?vue&type=script&lang=js"

import "./CInputNaive.vue?vue&type=style&index=0&id=2a2ef2ec&lang=scss&scoped=true"

import exportComponent from "/builds/advocacy/e-advokat-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a2ef2ec"]])

export default __exports__